import styled from 'styled-components';

export const SearchConditionOuter = styled.div`
  padding: 0.5rem 0.5rem;
  margin: 0.5rem 0.5rem;
  & + & {
    border-top: 1px solid #c8c8c8;
  }
`